import { ToastMessageService } from './layout/toast-message/toast-message.service';
import { EnvironmentProviders, NgModule, Provider } from '@angular/core';
import { EntryPageComponent } from './entry-page/entry-page.component';
import { MessagesAreaContainerComponent } from './message-area-container/messages-area-container.component';
import { MasterAreaContainerComponent } from './master-area-container/master-area-container.component';
import { ModelContainerComponent } from './model-container/model-container.component';
import { ComponentLocator } from './component-locator';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { ModalService } from '../view-models/modal/modal.service';
import { ModalComponentService } from './modal/modal-component.service';
import { PopupViewModel } from '../view-models/modal/popup-view-model';
import { PopupContainerComponent } from './popup/popup-container.component';
import { ExternalModalViewModel } from '../view-models/modal/external-modal-view-model';
import { ExternalModalContainerComponent } from './external-modal-container/external-modal-container.component';
import { IframeComponent } from './iframe/iframe.component';
import { ZoomOrchestratorViewModel } from '../view-models/zoom/zoom-orchestrator-view-model';
import { ZoomContainerComponent } from './zoom/zoom-container/zoom-container.component';
import { ZoomComponentModule } from './zoom/zoom-component.module';
import { WingContainerComponent } from './wing-container/wing-container.component';
import { SnapShotListContainerComponent } from './snap-shot-list-container/snap-shot-list-container.component';
import { UserImageComponent } from './user-image/user-image.component';
import { NavigationPanelComponent } from './navigation-panel/navigation-panel.component';
import { NumeralService, NumericHelper } from '@nts/std/utility';
import { DynamicPresentationComponent } from './dynamic-presentation/dynamic-presentation.component';
import { EnterpriseSelectorViewModel } from '../view-models/modal/enterprise-selector-modal-view-model';
import { EnterpriseSelectorContainerComponent } from './enterprise-selector/enterprise-selector-container.component';
import { AddZoomModalViewModel } from '../view-models/zoom/zoom-list-view-model/modals/add-zoom-modal-view-model';
import { AddZoomModalContainerComponent } from './zoom/zoom-list/modals/add-zoom/add-zoom-modal-container.component';
import { EditZoomModalViewModel } from '../view-models/zoom/zoom-list-view-model/modals/edit-zoom-modal-view-model';
import { EditZoomModalContainerComponent } from './zoom/zoom-list/modals/edit-zoom/edit-zoom-modal-container.component';
import { PinIdentityToDashboardModalContainerComponent } from './pin-identity-to-dashboard-modal-container/pin-identity-to-dashboard-modal-container.component';
import { PinIdentityToDashboardModalViewModel } from '../view-models/modal/pin-identity-to-dashboard-modal-view-model';
import { LayoutModule } from './layout/layout.module';
import { ModalContainerComponent } from './modal/modal-container.component';
import { NTSTranslatePipe } from './pipe/nts-translation-pipe';
import { NTSFilterPipe } from './pipe/nts-filter-pipe';
import { NTSCustomFilterPipe } from './pipe/nts-custom-filter-pipe';
import { SharedModule } from './shared/shared.module';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { ControlsComponentModule } from './controls/controls-component.module';
import { ErrorsComponentModule } from './errors/errors-component.module';
import { NumeralLoaderService } from '@nts/std/utility';
import { ExceptionPopupViewModel } from '../view-models/modal/exception-popup-view-model';
import { ExceptionPopupContainerComponent } from './exception-popup';

import moment from 'moment';
// Use this import for all the languages
// @ts-ignore
import 'moment/min/locales';

@NgModule({
  imports: [
    ControlsComponentModule,
    DynamicPresentationComponent,
    EnterpriseSelectorContainerComponent,
    EntryPageComponent,
    ErrorsComponentModule,
    ExternalModalContainerComponent,
    IframeComponent,
    LayoutModule,
    MasterAreaContainerComponent,
    MessagesAreaContainerComponent,
    ModalContainerComponent,
    ModelContainerComponent,
    NavigationPanelComponent,
    PinIdentityToDashboardModalContainerComponent,
    NTSFilterPipe,
    NTSCustomFilterPipe,
    NTSTranslatePipe,
    PopupContainerComponent,
    ExceptionPopupContainerComponent,
    SharedModule,
    SnapShotListContainerComponent,
    UserImageComponent,
    WingContainerComponent,
    ZoomComponentModule,

    MatDialogModule,

  ],
  exports: [
    ControlsComponentModule,
    DynamicPresentationComponent,
    EnterpriseSelectorContainerComponent,
    EntryPageComponent,
    ErrorsComponentModule,
    ExternalModalContainerComponent,
    IframeComponent,
    LayoutModule,
    MasterAreaContainerComponent,
    MessagesAreaContainerComponent,
    ModalContainerComponent,
    ModelContainerComponent,
    NavigationPanelComponent,
    PinIdentityToDashboardModalContainerComponent,
    NTSFilterPipe,
    NTSCustomFilterPipe,
    NTSTranslatePipe,
    PopupContainerComponent,
    ExceptionPopupContainerComponent,
    SharedModule,
    SnapShotListContainerComponent,
    UserImageComponent,
    WingContainerComponent,
    ZoomComponentModule,

    MatDialogModule,
  ],
  providers: [

  ]
})
export class ComponentsModule {

  constructor(
    private componentLocator: ComponentLocator,

    // Necessario per caricare numeral service la prima volta
    numeralLoaderService: NumeralLoaderService,
    primeNGConfig: PrimeNGConfig
  ) {

    this.registerDialogs();

    numeralLoaderService.init();

    // load correct culture file
    const language = navigator.language;

    try {

      NumericHelper.initCurrentNumericLocale();
      if (!(language === 'en' || language === 'en-US')) {
        moment.locale(language);
      }

    } catch (e) {

      // Fallback su italiano in caso di errrore
      NumeralService.Current.locale('it');
      moment.locale('it');
    }
    NumeralService.Current.defaultFormat('0,.00');

    primeNGConfig.setTranslation({
      dayNames: moment.localeData().weekdays(),
      dayNamesShort: moment.localeData().weekdaysShort(),
      dayNamesMin: moment.localeData().weekdaysMin(),
      monthNames: moment.localeData().months(),
      monthNamesShort: moment.localeData().monthsShort(),
      clear: '',
      today: '',
      firstDayOfWeek: moment.localeData().firstDayOfWeek()
    });
  }

  static getRootProviders(): Array<Provider | EnvironmentProviders> {
    return [
      MessageService,
      ToastMessageService,
      PrimeNGConfig,
      {
        provide: ModalService,
        useClass: ModalComponentService,
      },
      {
        provide: MAT_DIALOG_DEFAULT_OPTIONS,
        useValue: {
          panelClass: ['nts-dialog-container'],

          // necessario per gestire l'esc e il click fuori in modo custom con la condizione di viewModel.closeModal
          disableClose: true
        }
      },
      ComponentLocator
    ];
  }

  private registerDialogs() {

    this.componentLocator.registerViewModelComponentAssociation(
      ExceptionPopupViewModel, ExceptionPopupContainerComponent);

    this.componentLocator.registerViewModelComponentAssociation(
      PopupViewModel, PopupContainerComponent);

    this.componentLocator.registerViewModelComponentAssociation(
      ExternalModalViewModel, ExternalModalContainerComponent);

    this.componentLocator.registerViewModelComponentAssociation(
      ZoomOrchestratorViewModel, ZoomContainerComponent);

    this.componentLocator.registerViewModelComponentAssociation(
      EnterpriseSelectorViewModel, EnterpriseSelectorContainerComponent);

    this.componentLocator.registerViewModelComponentAssociation(
      AddZoomModalViewModel, AddZoomModalContainerComponent);

    this.componentLocator.registerViewModelComponentAssociation(
      EditZoomModalViewModel, EditZoomModalContainerComponent);

    this.componentLocator.registerViewModelComponentAssociation(
      PinIdentityToDashboardModalViewModel, PinIdentityToDashboardModalContainerComponent);
  }
}
